<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="aha-container flex flex-row max-sm:flex-col gap-4 max-sm:gap-0 ">
      <div
        v-for="(price, index) in getPrices"
        :key="price.label"
        :class="isEditor? 'editor-wrapper': ''"
        class="aha__card-wrapper"
      >
        <div>
          <div class="aha__banner">
            <div
              class="aha__title_pricing flex justify-between"
            >
              {{ price.label }}
              <img :src="require('@/assets/images/pricing/'+ (index+1)+'.svg' )">
            </div>
          </div>
          <div class="aha__body_pricing">
            <div class="aha__price-info">
              <span class="aha__price"> ${{ price.price }}</span>
              <span
                class="aha__price aha__smaller-price"
              >
                <div :class="{'opacity-0': price['smaller-price'] ===0}">.{{ price['smaller-price'] }}</div>
              </span>
              <div :class="{'opacity-0': price['smaller-price'] ===0}">
                <div class="aha__billing">
                  / mo
                </div>
              </div>
            </div>
            <div class="aha-decsription items-center">
              {{ $i18nPresenter.t('Audience size:') }}
              <aha-icon name="audience" />
              <div
                class="underline cursor-pointer font-bold"
                v-tooltip="$i18nPresenter.t('Max. number of people who can join and interact with your presentation simultaneously.')"
              >
                {{ price.maxParticipants }}
              </div>
            </div>
          </div>

          <div class="aha__single-user aha__single-user--40" />

          <div class="aha__plan-info" :class="{'aha-plan-free': price.label === 'Free'}">
            <aha-button
              class="action-button"
              v-if="price.label !== 'Free'"
              type="button"
              :disabled="permission[price.permissionKey]"
              @click="goToUpgradePage(price.upgradeLink)"
            >
              {{ $i18nPresenter.t('Upgrade') }}
            </aha-button>
            <span>
              {{ $i18nPresenter.t(price.description) }}
              <div class="aha-list-feature">
                <div v-for=" feature in price.listFeature " :key="feature">
                  <div class="aha__item_feature ">
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.50156 14.4001C12.0362 14.4001 14.9016 11.5347 14.9016 8.0001C14.9016 4.46548
                          12.0362 1.6001 8.50156 1.6001C4.96694 1.6001 2.10156 4.46548 2.10156 8.0001C2.10156
                          11.5347 4.96694 14.4001 8.50156 14.4001ZM10.9524 5.25556L7.30251 8.87782L6.09157
                          7.68358C5.74958 7.34631 5.20138 7.34219 4.85437 7.67428C4.49306 8.02004 4.4885 8.59586
                          4.84429 8.9473L6.69891 10.7792C7.03308 11.1093 7.57089 11.1083 7.90377 10.7769L12.1945
                            6.50527C12.535 6.16629 12.5412 5.617 12.2083 5.27052C11.8673 4.91561 11.3017 4.90887
                              10.9524 5.25556Z"
                        fill="#33C173"
                      />
                    </svg>
                    {{ $i18nPresenter.t(feature) }}
                  </div>
                </div>
              </div>
              <br>
              <span v-if="!isEditor" class="aha-more-detail max-sm:hidden" @click="$emit('learnMore', price.planKey)">
                {{ $i18nPresenter.t('Details') }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import featuresByPlan from './featuresByPlan'
import Utils from '@/util'
import Config from '@/config'

export default {
  props: {
    isEditor: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Object,
      default: () => {},
    },
    planName: {
      type: String,
      default: 'annual',
    },
    toggleButtonSwitch: {
      type: Function,
    },
  },
  data() {
    return {
      featuresByPlan,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    getPlan() {
      return this.featuresByPlan[this.planName]
    },
    getPrices() {
      return this.featuresByPlan[this.planName].planPrices.filter((plan) => {
        if (this.isEditor) {
          return !this.permission[plan.permissionKey] && plan.label !== 'Free'
        }
        return true
      })
    },
  },
  methods: {

    goToUpgradePage(url) {
      const plan = /content=([^&]+)/.exec(url)[1] || ''
      const planType = `${plan}`
      setTimeout(() => {
        if (this.isEditor) {
          const paramBackLink = `&back_link_to_presentation=${encodeURIComponent(window.location.href)}&trace=plan_list`
          window.location.href = `${Config.presenterDomain}${url}${paramBackLink}`
          Utils.mixpanelTracking('Presentation Editor', 'Choose a plan pop-up > Upgrade', planType, {
            plan: this.planName,
          })
          return
        }
        Utils.mixpanelTracking('My plan > Upgrade > Top', 'Upgrade', planType)
        window.location.href = `${Config.presenterDomain}${url}`
      }, 500)
    },
  },
}
</script>
<style lang="scss">
.aha__title_pricing{
  font-size: 24px;
  color: var(--base-90, #313131);
  font-weight: bold;
  display: flex;
  align-items: center;
}
.aha-container{
  @media (max-width: 768px) {
   flex-direction: column;
    gap: 0px;
    .aha__card-wrapper{
      margin-top: 16px;
    }
    .aha-more-detail{
      display: none;
    }
  }
}
.aha__title{
  font-size: 26px;
  margin-bottom: 15px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: bold;
}
.action-button{
  width: 100%;

  margin-bottom: 28px;
}
.aha-decsription{

  display: flex;
  font-size: 16px;
  margin-top: 16px;
  color: var(--base-90, #313131);
  svg{
    fill: var(--base-90, #313131);
    margin-left: 4px;
  }
}

.aha__banner{
  border-radius: 8px 8px 0px 0px;
  padding: 16px;
  background: var(--secondary-10, #F0F4FA);
}
.aha__billing_yearly {
  color: var(--base-80, #707070);
  font-size: 14px;
  .aha__billing_money{
    font-weight: bold;
  }
}
.aha__cards {
  min-height: 400px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}
.aha__card-wrapper {
  margin-top: 36px;
  position: relative;
  flex-grow: 1;
  flex-basis: 0;
  border: 1px solid var(--secondary-20, #D3D7E1);
  border-radius: 8px;
}
.editor-wrapper {
  margin-top: 24px;
}

.aha__card-wrapper--green {
  flex-grow: 1;
}

.aha__card {
  padding-top: 35px;
  padding-bottom: 36px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  z-index: 2;
}
.aha__body_pricing{
  padding: 20px 16px;
}
.aha__price-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: left;
  align-items: center;
  padding-bottom: 5px;
}
.aha__plan-free{
  padding-bottom:61px;
  @media (max-width: 768px) {
    padding-bottom: 0px;
  }
}
.aha__plan-info{
padding: 0px 16px 16px 16px
}
.aha-plan-free{
  padding-top : 60px;
}
.aha__currency {
  font-size: 18px;
  color: var(--base-90, #313131);
  padding-right: 5px;
}
.aha__price {
  font-weight: bold;
  font-size: 32px;
  color: var(--base-90, #313131);
  padding-right: 6px;
}
.aha__billing {
  color: var(--base-70, #999);
  /* Presentation App/Heading/H3 */
  font-family: Nunito;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 6px;
}
.aha__smaller-price {
  font-size: 20px;
  margin-top: 8px;
  margin-left: -5px;
}

.aha-number-participant{
  text-decoration-line: underline;

}

.aha-free-pricing{
  margin-bottom: 12px;
}
.aha__item_feature{
  display: grid;
  grid-template-columns: 17px auto;
  @apply gap-1;
  align-items: center;
}
.aha-list-feature{
  margin-top: 10px;
  display: flex;
  gap:8px;
  flex-direction: column;
}
.aha-more-detail{
  cursor: pointer;
  color: var(--primary-90, #348EF6);
  font-weight: 700;
  font-size: 14px;
}

.aha__billing_highlight{
  color: var(--green-50, #33C173);
}
</style>
